export const MINIMIZED_MODALS_MAX_COUNT = 1
